import Certificate from '@/service/certificate'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getcertificates(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.getcertificates(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getcertificate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.getcertificate(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addcertificate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.addcertificate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatecertificate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.updatecertificate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletecertificate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.deletecertificate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addcertificatefile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.addcertificatefile(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatecertificatefile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.updatecertificatefile(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletecertificatefile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Certificate.deletecertificatefile(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
